<div class="relative">
  <!-- Trigger Pill Button -->
  <button
    type="button"
    (click)="toggle()"
    [disabled]="disabled"
    [ngClass]="{
      'border-primary-300': dateSummary || isOpen(),
      'shadow-focus': isOpen(),
      'opacity-50 cursor-not-allowed': disabled
    }"
    [class]="pillClass"
    class="flex justify-between items-center px-3 py-1 rounded-[99px] border-[1px] border-solid border-brand-border bg-surface-card hover:border-primary-200 hover:bg-surface/80 outline-none focus:outline-none focus:border-primary-300 focus:shadow-focus transition-[background-color,border-color,box-shadow] cursor-pointer shadow-xs h-[32px]"
  >
    <span class="text-brand-muted font-medium text-xs leading-normal tracking-normal truncate">
      {{ label }}
    </span>

    @if (dateSummary) {
      <span class="bg-surface text-primary text-xs font-semibold px-2 py-0.5 rounded-md leading-normal truncate max-w-[120px]">
        {{ dateSummary }}
      </span>
    }

    <app-icon-chevron
      [class.rotate-180]="isOpen()"
      class="transition-transform duration-200 shrink-0"
    ></app-icon-chevron>
  </button>

  <!-- Popover Dropdown -->
  @if (isOpen()) {
    <div
      (click)="$event.stopPropagation()"
      [ngClass]="align === 'right' ? 'right-0' : 'left-0'"
      [class]="dropdownClass"
      class="absolute top-full mt-2 z-50 bg-white border border-gray-200 rounded-2xl shadow-xl p-4 text-sm"
    >
      <div class="text-xs font-bold text-gray-400 tracking-wider uppercase mb-2">
        {{ 'REQUESTLIST.FILTERS.PERIOD' | translate }}
      </div>

      <div class="space-y-1 mb-4">
        @for (preset of presets; track preset.id) {
          <button
            type="button"
            (click)="selectPreset(preset.id)"
            [ngClass]="{'text-primary bg-surface': selectedPreset() === preset.id}"
            class="w-full text-left px-3 py-2 rounded-xl hover:bg-surface font-medium transition-colors flex items-center gap-2 cursor-pointer"
          >
            <div class="w-4 h-4 rounded-full border border-gray-400 flex items-center justify-center shrink-0">
              @if (selectedPreset() === preset.id) {
                <div class="w-2.5 h-2.5 rounded-full bg-primary-700"></div>
              }
            </div>
            <span>{{ preset.labelKey | translate }}</span>
          </button>
        }
      </div>

      <div class="border-t border-gray-100 pt-3">
        <div class="text-xs font-bold text-gray-400 tracking-wider uppercase mb-2">
          {{ 'REQUESTLIST.FILTERS.PERIOD_CUSTOM' | translate }}
        </div>
        <div [formGroup]="activeFormGroup" class="space-y-2 mb-3">
          <div>
            <label class="block text-xs text-gray-500 mb-1">
              {{ 'REQUESTLIST.FILTERS.FROM' | translate }}
            </label>
            <input
              type="date"
              [formControlName]="activeStartControlName"
              (change)="onCustomDateChange()"
              class="w-full px-2.5 py-1.5 text-xs bg-surface-header/60 border-[1px] border-solid border-brand-border rounded-lg outline-none hover:border-primary-200 focus:bg-white focus:border-primary-300 focus:shadow-focus transition-[background-color,border-color,box-shadow]"
            />
          </div>
          <div>
            <label class="block text-xs text-gray-500 mb-1">
              {{ 'REQUESTLIST.FILTERS.TO' | translate }}
            </label>
            <input
              type="date"
              [formControlName]="activeEndControlName"
              (change)="onCustomDateChange()"
              class="w-full px-2.5 py-1.5 text-xs bg-surface-header/60 border-[1px] border-solid border-brand-border rounded-lg outline-none hover:border-primary-200 focus:bg-white focus:border-primary-300 focus:shadow-focus transition-[background-color,border-color,box-shadow]"
            />
          </div>
        </div>
        <div class="flex justify-end">
          <app-button size="sm" (btnClick)="onApply()">
            {{ 'REQUESTLIST.FILTERS.BUTTONS.APPLY' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  }
</div>
